// extracted by mini-css-extract-plugin
module.exports = {"bottom":"BottomControls_bottom__1x9Bl","backBtn":"BottomControls_backBtn__3DEdH"};